<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <!-- cluster filter -->
        <div class="col-lg-3">
          <base-input label="Cluster:">
            <el-select
              class="select-primary"
              placeholder="Choose..."
              size="large"
              v-model="selects.cluster"
              @change="getData(selects.cluster)"
            >
              <el-option
                style="color: #000000"
                v-for="option in selects.clusterarray"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg" style="text-align: center">
          <el-table
            :data="tableData"
            :header-cell-style="{
              background: 'transparent',
              border: 'transparent',
              'padding-bottom': '0%',
              'padding-center': '10px',
              color: 'white',
            }"
            :cell-style="{
              border: 'transparent',
              'padding-center': '20px',
            }"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column align="right" label="Action">
              <div slot-scope="props">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                  <base-button
                    @click.native="openmodal = true"
                    @click="getRow(props.row)"
                    class="edit btn-link"
                    type="success"
                    size="sm"
                    icon
                    :disabled="disableButton"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
          <i
            v-show="odload"
            class="fas fa-spinner fa-pulse"
            style="color: white; font-size: 60px"
          ></i>
          <base-button type="success" @click="sendData()">Submit </base-button>
          <modal
            :show.sync="openmodal"
            footer-classes="justify-content-center"
            type="notice"
          >
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="row justify-content-center mt-12">
                      <div class="col-sm-12">
                        <div>
                          <h3 style="color: #344675">Scheduler Information</h3>
                          <base-input
                            v-model="index"
                            type="text"
                            label="No: "
                            disabled
                          ></base-input>
                          <base-input
                            v-model="hour"
                            type="text"
                            label="Hour"
                            disabled
                          ></base-input>
                          <base-input
                            v-model="min"
                            type="text"
                            label="Min"
                            disabled
                          ></base-input>
                          <base-input label="On/Off">
                            <el-select
                              class="select-success"
                              size="large"
                              v-model="status"
                              type="text"
                              @change="detectBrightness()"
                            >
                              <el-option
                                v-for="option in selects.status"
                                class="select-success"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label"
                              >
                              </el-option>
                            </el-select>
                          </base-input>
                          <base-input label="Brightness">
                            <el-select
                              class="select-default"
                              size="large"
                              v-model="brightness"
                              type="text"
                            >
                              <el-option
                                v-for="option in selects.br"
                                class="select-success"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label"
                              >
                              </el-option>
                            </el-select>
                          </base-input>
                        </div>
                      </div>
                      <div>
                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click.native="handleEdit()"
                          >Submit</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="openmodal = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal>
        </div>
        <!-- <div class="col-lg">
          <div class="chart-area" style="text-align: center;">
            <bar-chart
              :chart-data="lineChart.chartData"
              :gradient-colors="lineChart.gradientColors"
              :gradient-stops="lineChart.gradientStops"
              :extra-options="lineChart.extraOptions"
              :height="300"
            ></bar-chart>
            <i
              v-if="odload"
              class="fas fa-spinner fa-pulse"
              style="color:white; font-size: 60px; "
            ></i>
          </div>
        </div> -->
        <div class="col-lg">
          <div class="chart-area" style="text-align: center">
            <line-chart
              :chart-data="lineChart.chartData"
              :gradient-colors="lineChart.gradientColors"
              :gradient-stops="lineChart.gradientStops"
              :extra-options="lineChart.extraOptions"
              :height="300"
            ></line-chart>
            <i
              v-if="odload"
              class="fas fa-spinner fa-pulse"
              style="color: white; font-size: 60px"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import { Modal, BasePagination } from "src/components";
import swal from "sweetalert2";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import Tab from "../../components/Tabs/Tab.vue";
import BaseTable from "../../components/BaseTable.vue";
import { time } from "d3";
// import { filterSegsViaEls } from 'fullcalendar/src/component/event-rendering';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    BarChart,
    Modal,
    BasePagination,
    Tab,
  },
  props: BaseTable["test"],
  data() {
    return {
      selects: {
        cluster: "",
        clusterarray: [],
        br: [
          { value: 10, label: "10" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 40, label: "40" },
          { value: 50, label: "50" },
          { value: 60, label: "60" },
          { value: 70, label: "70" },
          { value: 80, label: "80" },
          { value: 90, label: "90" },
          { value: 100, label: "100" },
        ],
        status: [
          {
            value: "On",
            label: "On",
          },
          {
            value: "Off",
            label: "Off",
          },
        ],
      },
      defaultData: [],
      tableData: [],
      odload: false,
      openmodal: false,
      disableButton: true,
      disableBr: false,
      tableColumns: [
        {
          prop: "index",
          label: "No:",
        },
        {
          prop: "hour",
          label: "Hour",
          // minWidth: 200
        },
        {
          prop: "min",
          label: "Min",
          // minWidth: 250
        },
        {
          prop: "status",
          label: "Status",
          // minWidth: 250
        },
        {
          prop: "brightness",
          label: "Brightness",
          // minWidth: 250
        },
      ],
      lineChart: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Brightness",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        // loaded: false,
        // extraOptions: chartConfigs.aChartOptions,
        // gradientColors: [
        //   "rgba(82, 222, 151, 0.5)",
        //   "rgba(82, 222, 151, 0.3)",
        //   "rgba(82, 222, 120, 0.1)"
        // ],
        // gradientStops: [1, 0.4, 0]
      },
      header: "",
      index: "",
      hour: "",
      min: "",
      status: "",
      brightness: "",
      onoff: "",
      profile: "",
      clusterid: "",
      listCluster: [],
    };
  },
  methods: {
    sendData() {
      let fullarray = [];

      // find connection type and multicast id
      let conntype = "";
      let multicastid = "";
      for (var i = 0; i < this.listCluster.length; i++) {
        if (this.clusterid == this.listCluster[i].cluster_info.clusterid) {
          conntype = this.listCluster[i].cluster_info.conntype;
          multicastid = this.listCluster[i].cluster_info.multicastid;
        }
      }

      // convert to hex
      for (var i = 0; i < this.tableData.length; i++) {
        // convert header to hex
        let hexHeader = "0" + (this.tableData[i].header & 0xff).toString(16);
        // console.log("hex header : " + hexHeader);

        // convert profile to hex
        let hexProfile = "0" + (this.tableData[i].profile & 0xff).toString(16);
        // console.log("hex profile: " + hexProfile);

        //convert index to hex
        let hexIndex = "0" + (this.tableData[i].index & 0xff).toString(16);
        // console.log("hex index: " + hexIndex);

        // convert hour to hex
        let hexHour = (
          "0" + (this.tableData[i].hour & 0xff).toString(16)
        ).slice(-2);
        // console.log("hex hour : " + hexHour);

        // convert min to hex
        let hexMin = ("0" + (this.tableData[i].min & 0xff).toString(16)).slice(
          -2
        );
        // console.log("hex min : " + hexMin);

        // convert on off to hex

        var hexOnOff = "0" + this.tableData[i].onoff;
        // console.log("hex on off : " + hexOnOff);

        var hexBrightness =
          "0" + (this.tableData[i].brightness / 10).toString(16);
        // convert brightness to hex

        // arrange all hex value in one var
        var hexValue =
          hexHeader +
          hexProfile +
          hexIndex +
          hexHour +
          hexMin +
          hexOnOff +
          hexBrightness;
        // console.log("hex value : " + hexValue);

        fullarray.push(hexValue);
      }
      // console.log(fullarray);

      // find changes
      let changes = [];
      for (var i = 0; i < this.tableData.length; i++) {
        if (fullarray[i] !== this.defaultData[i]) {
          // console.log(fullarray[i]);
          // console.log(this.defaultData[i]);
          changes.push(fullarray[i]);
        }
      }

      // convert changes to base 64
      let convertchanges = [];
      let test = [];
      for (var i = 0; i < changes.length; i++) {
        let base64value = btoa(
          String.fromCharCode.apply(
            null,
            changes[i]
              .replace(/\r|\n/g, "")
              .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
              .replace(/ +$/, "")
              .split(" ")
          )
        );
        // console.log(base64value);
        convertchanges.push(base64value);

        let queue = {
          data: base64value,
        };
        test.push(queue);
      }
      console.log(test);

      // hantar 1
      let payload = {
        conntype: conntype,
        context: "RAW",
        command: test,
      };
      console.log("multicast id", multicastid);
      this.$http
        .post(":8003/api/v1/control/light/multicast/" + multicastid, payload)
        .then((res) => {
          if (!res.error) {
            console.log(res.message);
          } else {
            console.log(res.message);
          }
        });

      // hantar 2
      let payload2 = {
        type: "WEEKDAYS",
        data: fullarray,
      };

      this.$http
        .put(":8004/api/v1/session/cluster/" + this.clusterid, payload2)
        .then((res) => {
          if (!res.error) {
            swal({
              type: "success",
              title: "Changes Submitted!",
            });
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          }
        });

      this.getData(this.clusterid);
    },
    handleEdit() {
      // console.log(
      this.brightness,
        this.header,
        this.hour,
        this.min,
        this.onoff,
        this.profile,
        this.index;
      // );

      let payload = {
        header: this.header,
        profile: this.profile,
        index: this.index,
        hour: this.hour,
        min: this.min,
        onoff: this.onoff,
        brightness: this.brightness,
        status: this.status,
      };
      // console.log(payload);

      // load updated data
      this.tableData[this.index] = payload;

      // refresh table
      this.tableData.splice(this.tableData.length, this.tableData.length);
      // console.log(this.tableData[this.index]);

      this.openmodal = false;
    },
    detectBrightness() {
      if (this.status == "Off") {
        this.brightness = 0;
        this.onoff = 0;
      }
      if (this.status == "On") {
        this.onoff = 1;
      }
    },
    getRow(row) {
      // console.log(row);
      this.header = row.header;
      this.brightness = row.brightness;
      this.hour = row.hour;
      this.min = row.min;
      this.index = row.index;
      this.onoff = row.onoff;
      this.profile = row.profile;
      this.status = row.status;
    },
    loadGraph(timestamp, brightness) {
      // console.log(timestamp);
      // console.log(brightness);

      this.lineChart = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "Brightness",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: brightness,
            },
          ],
        },
        // loaded: true,
        // extraOptions: chartConfigs.aChartOptions,
        // gradientColors: [
        //   "rgba(82, 222, 151, 0.5)",
        //   "rgba(82, 222, 151, 0.3)",
        //   "rgba(82, 222, 120, 0.1)"
        // ],
        // gradientStops: [1, 0.4, 0]
      };
    },
    getData(clusterid) {
      // this.lineChart.loaded = false;
      this.odload = true;
      this.tableData = [];
      this.defaultData = [];

      // globalise cluster id
      this.clusterid = clusterid;

      this.$http.get(":8002/api/v1/manage/cluster/" + clusterid).then((res) => {
        if (!res.error) {
          // console.log("RES_MESsAGE: " , res)
          let response = res.message.schedule_info.weekdays;
          // console.log(response);
          this.defaultData = response;
          // separate data to readable format
          let timestamp = [];
          let brightness = [];
          for (var i = 0; i < response.length; i++) {
            // convert on off for display
            var onoff = "";
            if (parseInt(response[i].slice(10, 12), 16) == 0) {
              onoff = "Off";
            } else {
              onoff = "On";
            }

            var my_weekdays = {
              header: parseInt(response[i].slice(0, 2), 16),
              profile: parseInt(response[i].slice(2, 4), 16),
              index: parseInt(response[i].slice(4, 6), 16),
              hour: parseInt(response[i].slice(6, 8), 16),
              min: parseInt(response[i].slice(8, 10), 16),
              onoff: parseInt(response[i].slice(10, 12), 16),
              brightness: parseInt(response[i].slice(12, 14), 16) * 10,
              status: onoff,
            };

            // console.log(my_weekdays.onoff);
            this.tableData.push(my_weekdays);

            this.odload = false;

            // combine hour and min
            let time = my_weekdays.hour + ":" + my_weekdays.min;
            timestamp.push(time);

            // get brightness
            let br = my_weekdays.brightness;
            brightness.push(br);
          }

          // load graph
          this.loadGraph(timestamp, brightness);
        }
      });
    },
    getlist() {
      this.$http.get(":8002/api/v1/manage/cluster").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response)
          // pass value select
          let arr = res.message.cluster_list;
          for (var i = 0; i < arr.length; i++) {
            let obj = {
              value: arr[i].cluster_info.clusterid,
              label: arr[i].cluster_info.clustername,
            };
            this.selects.clusterarray.push(obj);
            this.listCluster.push(arr[i]);
          }

          // assign default cluster
          this.selects.cluster = this.selects.clusterarray[0].value;

          // call table data
          this.getData(this.selects.cluster);
        } else {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        }
      });
    },
  },
  created() {
    let roleSession = JSON.parse(sessionStorage.getItem("accessList"));

    // console.log(roleSession.length);
    for (var i = 0; i < roleSession.length; i++) {
      // // console.log(JSON.parse)
      // console.log(roleSession[i]);
      if (roleSession[i] === "cluster.update") {
        // console.log("cluster.update role access");
        this.disableButton = true;
        // this.disabledButton = true;
      }
      if (roleSession[i] === "admin.view") {
        this.disableButton = false;
      }
      if (roleSession[i] === "cluster.update") {
        this.disableButton = false;
      }
    }
    this.getlist();
  },
  computed: {},
};
</script>
